

import { Utils } from "../../utils.js";
import { withMeasurementDisplayOffset } from "../../utils/SharedUtils.js";

const INTERNAL_POINT_KEYS = new Set(["position", "snapSource"]);

function formatPointAttributeValue(value) {
  if (value == null) {
    return "";
  }
  if (Array.isArray(value)) {
    return value.join(", ");
  }
  if (typeof value === "number") {
    return Utils.addCommas(value.toFixed(3));
  }
  return String(value);
}

export class MeasurePanel {

  constructor(viewer, measurement, propertiesPanel) {
    this.viewer = viewer;
    this.measurement = measurement;
    this.propertiesPanel = propertiesPanel;

    this._update = () => { this.update(); };
  }

  createCoordinatesTable(points) {
    let table = $(`
			<table class="measurement_value_table">
				<tr>
					<th>x</th>
					<th>y</th>
					<th>z</th>
					<th></th>
				</tr>
			</table>
		`);

    let copyIconPath = Potree.resourcePath + '/icons/copy.svg';
    const offset = this.viewer?.measurementDisplayOffset ?? null;

    for (let point of points) {
      let [dx, dy, dz] = withMeasurementDisplayOffset(point, offset);
      let x = Utils.addCommas(dx.toFixed(3));
      let y = Utils.addCommas(dy.toFixed(3));
      let z = Utils.addCommas(dz.toFixed(3));
      let row = $(`
				<tr>
					<td><span>${x}</span></td>
					<td><span>${y}</span></td>
					<td><span>${z}</span></td>
					<td align="right" style="width: 25%">
						<img name="copy" title="copy" class="button-icon" src="${copyIconPath}" style="width: 16px; height: 16px"/>
					</td>
				</tr>
			`);

      this.elCopy = row.find("img[name=copy]");
      this.elCopy.click(() => {
        let msg = withMeasurementDisplayOffset(point, offset)
          .map(c => c.toFixed(3))
          .join(", ");
        Utils.clipboardCopy(msg);

        this.viewer.postMessage(
          `Copied value to clipboard: <br>'${msg}'`,
          { duration: 3000 });
      });

      table.append(row);
    }

    return table;
  };

  createAttributesTable() {
    let elTable = $('<table class="measurement_value_table"></table>');

    let point = this.measurement.points[0];

    const translate = (name) => {
      const key = `appearance.attr_${name.replace(/[\s-]/g, '_')}`;
      return (typeof i18n !== 'undefined') ? i18n.t(key, { defaultValue: name }) : name;
    };

    for (let attributeName of Object.keys(point)) {
      if (INTERNAL_POINT_KEYS.has(attributeName)) {
        continue;
      }

      const value = point[attributeName];
      const text = formatPointAttributeValue(value);
      if (!text) {
        continue;
      }

      const label = translate(attributeName);
      elTable.append($(`
					<tr>
						<td>${label}</td>
						<td>${text}</td>
					</tr>
				`));
    }

    return elTable;
  }

  update() {

  }
};